import { FacebookMessengerLinkListener } from "./facebook-messenger-link-listener";

/**
 * Opens "Chat on Messenger" links (ISS-09-008) in a small popup window
 * instead of a full new tab — document-level delegation, so it also covers
 * the create-review modal's copy, which is injected via AJAX after load.
 */
export class FacebookMessengerLinkSetup {
    public static init(): void {
        new FacebookMessengerLinkListener().register();
    }
}
